module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/82bd827e61aa30d570d249f571ef7e01.png";